module.exports = __webpack_public_path__ + "static/media/cerca-eletronica.2380dba0.svg";